import type { ReactNode } from 'react';
import { InfoTip } from '../../components/ui/InfoTip';

/**
 * The one control row at the top of a Sales tab: a view switch on the left, the
 * grey sync/meta line with the "how this is counted" (i) next to it, and the
 * period control on the right.
 */
export function SectionToolbar({
  leading,
  meta,
  info,
  actions,
}: {
  leading?: ReactNode;
  meta?: ReactNode;
  info?: ReactNode;
  actions?: ReactNode;
}) {
  if (!leading && !meta && !info && !actions) return null;
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="flex min-w-0 flex-wrap items-center gap-3">
        {leading}
        {(meta || info) && (
          <div className="flex min-w-0 items-center gap-1.5 text-body-xs text-text-tertiary">
            {meta}
            {info && <InfoTip>{info}</InfoTip>}
          </div>
        )}
      </div>
      {/* ml-auto: when the row wraps, the period control stays on the right, as on every other tab. */}
      {actions && <div className="ml-auto flex flex-none items-center gap-2">{actions}</div>}
    </div>
  );
}
